const mockData = [
  {
    id: 11333,
    pagetitle: "1832 / SLC / СИЛИЯ / ПЛАТЬЕ, цвет ЧЕРНЫЙ, M, L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "ПЛАТЬЕ, цвет ЧЕРНЫЙ, размеры S, M, L, Материал - 97% Полиэстер 3% Эластан",
    article: "183212",
    price: 1396,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["L", "M"],
    quantity: "1",
    guid: "fe580405-c33e-11e4-810d-001e67a49630",
    ean: "5906340731473",
    brand: "SoftLine",
    code: "5591183212",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1832 12",
    material: "97% Полиэстер 3% Эластан",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591183212.jpg",
    photo2: "http://zdjecia.slc.pl/5591183211_1.jpg",
    photo3: ""
  },
  {
    id: 11054,
    pagetitle: "1804 / SLC / ОРСОЛА / БОДИ, цвет БЕЛЫЙ, M / L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "БОДИ выполнено из ажурного материала, имеет открытые чашечки на которые нежно спускается полупрозрачная оборка. Между грудей маленький нарядный бантик со стразинкой. Боди сзади на завязках. На трусики с разрезом нежно спускается полупрозрачная оборка. цвет БЕЛЫЙ. размер S/M, M/L. Материал - 80% Полиамид, 20% Эластан.",
    article: "180427",
    price: 1179,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["M / L"],
    quantity: "1",
    guid: "01533902-f6ca-11e3-80c9-001e67a49630",
    ean: "5906340727810",
    brand: "SoftLine",
    code: "5591180427",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1804 27",
    material: "90% Полиамид 10% Эластан",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591180427.jpg",
    photo2: "http://zdjecia.slc.pl/5591180427_1.jpg",
    photo3: "http://zdjecia.slc.pl/5591180427_2.jpg"
  },
  {
    id: 9812,
    pagetitle: "6268 / SLC / КЭСТСЬЮИТ, цвет ЧЕРНЫЙ, S-L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "КЭТСЬЮИТ - КОСТЮМ-СЕТКА, цвет ЧЕРНЫЙ, размер S/L. Материал - 85% Полиамид, 15% Эластан.",
    article: "626810",
    price: 1011,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["S-L"],
    quantity: "1",
    guid: "ef65d040-f6c9-11e3-80c9-001e67a49630",
    ean: "5906340729296",
    brand: "Bodystockings",
    code: "5576626810",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "6268 10",
    material: "85% Нейлон 15% Спандекс",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5576626810.jpg",
    photo2: "http://zdjecia.slc.pl/5576626810_1.jpg",
    photo3: ""
  },
  {
    id: 11323,
    pagetitle:
      "1824 / SLC / ЛИЛИ / НОЧНАЯ СОРОЧКА И СТРИНГИ, цвет ЧЕРНЫЙ, S / M",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "НОЧНАЯ СОРОЧКА И СТРИНГИ, цвет ЧЕРНЫЙ, размеры S/M, M/L, Материал - 90% Полиамид 10% Лайкра",
    article: "182416",
    price: 1231,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["S / M"],
    quantity: "1",
    guid: "2437a261-815a-11e4-80df-001e67a49630",
    ean: "5906340731213",
    brand: "SoftLine",
    code: "5591182416",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1824 16",
    material: "90% Полиамид 10% Лайкра",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591182416.jpg",
    photo2: "http://zdjecia.slc.pl/5591182416_1.jpg",
    photo3: ""
  },
  {
    id: 11322,
    pagetitle:
      "1822 / SLC / САФОНА / НОЧНАЯ СОРОЧКА И СТРИНГИ, цвет БЕЛЫЙ, M / L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "НОЧНАЯ СОРОЧКА И СТРИНГИ, цвет БЕЛЫЙ, размеры S/M, M/L, Материал - 90% Полиамид 10% Лайкра",
    article: "182227",
    price: 1299,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["M / L"],
    quantity: "6",
    guid: "2437a260-815a-11e4-80df-001e67a49630",
    ean: "5906340731169",
    brand: "SoftLine",
    code: "5591182227",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1822 27",
    material: "90% Полиамид 10% Лайкра",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591182227.jpg",
    photo2: "http://zdjecia.slc.pl/5591182226_1.jpg",
    photo3: "http://zdjecia.slc.pl/5591182226_2.jpg"
  },
  {
    id: 10955,
    pagetitle: "1884 / SLC / 188417 / БОДИ LYNN цвет, ЧЕРНЫЙ, M / L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "Боди с прозрачным лифом без косточек, завязки фиксируются на шее и спине. Зона декольте дизайнерски украшена несколькими лямками.  Материал: 90% Полиамид 10% Лайкра. Цвет: Черный. Размер:  S/M, M/L",
    article: "188417",
    price: 1328,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["M / L"],
    quantity: "4",
    guid: "64bde45b-c17e-11e8-b060-1c1b0d11cfbe",
    ean: "5906340735952",
    brand: "SoftLine",
    code: "5591188417",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1884 17",
    material: "90% Полиамид 10% Лайкра",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591188417.jpg",
    photo2: "http://zdjecia.slc.pl/5591188417_1.jpg",
    photo3: "http://zdjecia.slc.pl/5591188417_2.jpg"
  },
  {
    id: 10789,
    pagetitle: "1884 / SLC / 188436 / БОДИ LYNN цвет, КРАСНЫЙ, S / M",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "Боди с прозрачным лифом без косточек, завязки фиксируются на шее и спине. Зона декольте дизайнерски украшена несколькими лямками.  Материал: 90% Полиамид 10% Лайкра. Цвет: Красный. Размер:  S/M, M/L",
    article: "188436",
    price: 1328,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["S / M"],
    quantity: "3",
    guid: "64bde45c-c17e-11e8-b060-1c1b0d11cfbe",
    ean: "5906340735488",
    brand: "SoftLine",
    code: "5591188436",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1884 36",
    material: "90% Полиамид 10% Лайкра",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591188436.jpg",
    photo2: "http://zdjecia.slc.pl/5591188436_1.jpg",
    photo3: "http://zdjecia.slc.pl/5591188436_2.jpg"
  },
  {
    id: 10273,
    pagetitle: "1870 / SLC / БОДИ NATALIE, цвет ЧЕРНЫЙ, M / L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "Боди с изящным сочетанием кружева и переплетением лент. Лиф без косточек. Материал: 89% Полиамид, 11% Эластан. Цвет: Черный. Размер: S/M, M/L.",
    article: "187017",
    price: 1338,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["M / L"],
    quantity: "4",
    guid: "cc50cd59-6a53-11e8-99b2-1c1b0d11cfbe",
    ean: "5906340735754",
    brand: "SoftLine",
    code: "5591187017",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1870 17",
    material: "89% Полиамид 11% Эластан",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591187017.jpg",
    photo2: "",
    photo3: ""
  },
  {
    id: 11328,
    pagetitle:
      "1823 / SLC / ВАНЕССА / НОЧНАЯ СОРОЧКА И СТРИНГИ, цвет ЧЕРНЫЙ, S / M, M / L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "НОЧНАЯ СОРОЧКА И СТРИНГИ, цвет ЧЕРНЫЙ, размеры S/M, M/L, Материал - 90% Полиамид 10% Лайкра",
    article: "182316",
    price: 1366,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["M / L", "S / M"],
    quantity: "1",
    guid: "fe5803f8-c33e-11e4-810d-001e67a49630",
    ean: "5906340731176",
    brand: "SoftLine",
    code: "5591182316",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1823 16",
    material: "90% Полиамид 10% Лайкра",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591182316.jpg",
    photo2: "http://zdjecia.slc.pl/5591182316_1.jpg",
    photo3: ""
  },
  {
    id: 11330,
    pagetitle:
      "1823 / SLC / ВАНЕССА / НОЧНАЯ СОРОЧКА И СТРИНГИ, цвет БЕЛЫЙ, S / M, M / L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "НОЧНАЯ СОРОЧКА И СТРИНГИ, цвет БЕЛЫЙ, размеры S/M, M/L, Материал - 90% Полиамид 10% Лайкра",
    article: "182326",
    price: 1366,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["M / L", "S / M"],
    quantity: "1",
    guid: "fe5803fa-c33e-11e4-810d-001e67a49630",
    ean: "5906340731190",
    brand: "SoftLine",
    code: "5591182326",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1823 26",
    material: "90% Полиамид 10% Лайкра",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591182326.jpg",
    photo2: "http://zdjecia.slc.pl/5591182326_1.jpg",
    photo3: ""
  },
  {
    id: 11199,
    pagetitle:
      "1717 / SLC / ФИОР / НОЧНАЯ СОРОЧКА И СТРИНГИ, цвет ЧЕРНЫЙ, M / L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "НОЧНАЯ СОРОЧКА И СТРИНГИ. Сорочка на тонких бретельках, выполненная из эластичного материала, с декоративной вставкой под грудью, слегка расширяется снузу. цвет ЧЕРНЫЙ. размер S/M, M/L. Материал - 80% Полиамид, 20% Эластан.",
    article: "171717",
    price: 1376,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["M / L"],
    quantity: "1",
    guid: "f56019f1-f6c9-11e3-80c9-001e67a49630",
    ean: "5906340722822",
    brand: "SoftLine",
    code: "5591171717",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1717 17",
    material: "80% Полиамид 20% Спандекс",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591171717.jpg",
    photo2: "",
    photo3: ""
  },
  {
    id: 10278,
    pagetitle: "1873 / SLC / КОМПЛЕКТ: ЛИФ И ТРУСИКИ JANET, цвет ЧЕРНЫЙ, M, L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "Комплект: Кружевной лиф на косточках, с двойной эластичной лентой, проходящей по линии декольте. Трусики кружевные c доступом, двойная эластичная лента повторяет дизайн лифа. Материал: 89% Полиамид, 11% Эластан. Цвет: Черный. Размер: S, M, L.",
    article: "187312",
    price: 1395,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["L", "M"],
    quantity: "3",
    guid: "cc50cd5f-6a53-11e8-99b2-1c1b0d11cfbe",
    ean: "5906340735785",
    brand: "SoftLine",
    code: "5591187312",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1873 12",
    material: "89% Полиамид 11% Эластан",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591187312.jpg",
    photo2: "",
    photo3: ""
  },
  {
    id: 11334,
    pagetitle: "1832 / SLC / СИЛИЯ / ПЛАТЬЕ, цвет ЧЕРНЫЙ, M, L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "ПЛАТЬЕ, цвет ЧЕРНЫЙ, размеры S, M, L, Материал - 97% Полиэстер 3% Эластан",
    article: "183213",
    price: 1396,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["L", "M"],
    quantity: "5",
    guid: "fe580406-c33e-11e4-810d-001e67a49630",
    ean: "5906340731480",
    brand: "SoftLine",
    code: "5591183213",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1832 13",
    material: "97% Полиэстер 3% Эластан",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591183213.jpg",
    photo2: "http://zdjecia.slc.pl/5591183211_1.jpg",
    photo3: ""
  },
  {
    id: 11329,
    pagetitle:
      "1823 / SLC / ВАНЕССА / НОЧНАЯ СОРОЧКА И СТРИНГИ, цвет ЧЕРНЫЙ, S / M, M / L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "НОЧНАЯ СОРОЧКА И СТРИНГИ, цвет ЧЕРНЫЙ, размеры S/M, M/L, Материал - 90% Полиамид 10% Лайкра",
    article: "182317",
    price: 1366,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["M / L", "S / M"],
    quantity: "2",
    guid: "fe5803f9-c33e-11e4-810d-001e67a49630",
    ean: "5906340731183",
    brand: "SoftLine",
    code: "5591182317",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1823 17",
    material: "90% Полиамид 10% Лайкра",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591182317.jpg",
    photo2: "http://zdjecia.slc.pl/5591182316_1.jpg",
    photo3: ""
  },
  {
    id: 11331,
    pagetitle:
      "1823 / SLC / ВАНЕССА / НОЧНАЯ СОРОЧКА И СТРИНГИ, цвет БЕЛЫЙ, S / M, M / L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "НОЧНАЯ СОРОЧКА И СТРИНГИ, цвет БЕЛЫЙ, размеры S/M, M/L, Материал - 90% Полиамид 10% Лайкра",
    article: "182327",
    price: 1366,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["M / L", "S / M"],
    quantity: "9",
    guid: "fe5803fb-c33e-11e4-810d-001e67a49630",
    ean: "5906340731206",
    brand: "SoftLine",
    code: "5591182327",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1823 27",
    material: "90% Полиамид 10% Лайкра",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591182327.jpg",
    photo2: "http://zdjecia.slc.pl/5591182326_1.jpg",
    photo3: ""
  },
  {
    id: 10279,
    pagetitle: "1873 / SLC / КОМПЛЕКТ: ЛИФ И ТРУСИКИ JANET, цвет ЧЕРНЫЙ, M, L",
    longtitle: "",
    description: "",
    introtext: null,
    content:
      "Комплект: Кружевной лиф на косточках, с двойной эластичной лентой, проходящей по линии декольте. Трусики кружевные c доступом, двойная эластичная лента повторяет дизайн лифа. Материал: 89% Полиамид, 11% Эластан. Цвет: Черный. Размер: S, M, L.",
    article: "187313",
    price: 1395,
    old_price: 0,
    weight: 0,
    new: false,
    popular: false,
    favorite: false,
    vendor: "SLC",
    size: ["L", "M"],
    quantity: "1",
    guid: "cc50cd60-6a53-11e8-99b2-1c1b0d11cfbe",
    ean: "5906340735792",
    brand: "SoftLine",
    code: "5591187313",
    basic_unit: "шт",
    vat_rate: "20",
    boxtype: "Картонная коробка",
    diameter: "",
    productioncode: "1873 13",
    material: "89% Полиамид 11% Эластан",
    vibration: "",
    volume: "",
    battery: "",
    photo1: "http://zdjecia.slc.pl/5591187313.jpg",
    photo2: "",
    photo3: ""
  }
];

const sizeMap = {
  11333: { L: 11334, M: 11333 },
  11334: { L: 11334, M: 11333 },
  11328: { "M / L": 11329, "S / M": 11328 },
  11329: { "M / L": 11329, "S / M": 11328 },
  11330: { "M / L": 11330, "S / M": 11331 },
  11331: { "M / L": 11330, "S / M": 11331 },
  10278: { L: 10279, M: 10278 },
  10279: { L: 10279, M: 10278 }
};

export {mockData, sizeMap};



// WEBPACK FOOTER //
// ./src/js/api/mockData.js